import script from "./message-input-reference-or-reply.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-reference-or-reply.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-reference-or-reply.vue?vue&type=style&index=0&id=1333615b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1333615b"]])

export default __exports__